import { usePaymentContext } from '../PaymentProvider';
import { PaymentMethodsEnum } from '../helpers';
import AppleWallet from './AppleWallet';
import GoogleWallet from './GoogleWallet';

const Wallets = () => {
  const { selectedPaymentMethod, walletToken } = usePaymentContext();

  if(!walletToken) return null;

  if (selectedPaymentMethod.id === PaymentMethodsEnum.Apple) return <AppleWallet />;
  if (selectedPaymentMethod.id === PaymentMethodsEnum.Google) return <GoogleWallet />;

  return null;
};

export default Wallets;
